import React, { Component } from "react";
import { Modal, ModalBody, ModalFooter, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { routes } from "../General";
import axios from "axios";
import { Coberturas } from "./compModal/Coberturas";
import { DeduciblesVehi } from "./compModal/Deducibles";
import { Notas } from "./compModal/Notas";
import { Clausulas } from "./compModal/Clausulas";
import { Contratante } from "./Contratante";
import { Pagos } from "./Facturacion";
import { Garantias } from "./compModal/Garantias";

export class CondicionesVehi extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            value: "",
            editing: false,
            item: {},
            hTabs: "ht1",
            coberturas: [],
            clausulas: [],
            deducibles: [],
            otros: [],
            garantias: [],
            notas: [],
            pagos: [],
            formaPago: {},
            totalPago: 0,
            totalSaldo: 0,
            tipo: 1, //por defecto vehiculo
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                // this.tipoContenido();
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    fetchData() {
        let { item, poliza } = this.props;
        // let tipo = this.state.tipo;
        let id = "";
        // if (tipo === 1) {
        //     id = (poliza.cdRamCotOri != null && (!item.numCotizacion.startsWith('R') && !item.numCotizacion.startsWith('C'))) ? poliza.cdRamCotOri : item.cdRamoCotizacion;
        // } else {
        //     id = poliza.cdRamoCotizacion;
        id = poliza.cdRamoCotizacion;
        // }
        this.getCoberturas(item.compania.cdCompania, id);
        this.getClausulas(item.compania.cdCompania, id);
        this.getDeducibles(item.compania.cdCompania, id);
        this.getGarantias(id);
        this.getNotas(id);
        this.getPagos(item.compania.cdCompania, item.cdCotizacion);
    }

    tipoContenido() {
        let item = this.props.item;
        axios
            .get(routes.api + "/polizas/tipo-contenido", { params: { cdRamoCotizacion: item.cdRamoCotizacion } })
            .then(resp => {
                let ramo = resp.data;
                let tipo;
                if (ramo != null && (ramo.nmRamo.includes("VIDA") || ramo.nmRamo.includes("MEDICA"))) {
                    tipo = 2;
                } else if (ramo != null && ramo.nmRamo.includes("VEHICULO")) {
                    tipo = 1;
                } else {
                    tipo = 0;
                }
                this.setState({ tipo: tipo });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    }

    getCoberturas = (idComp, cdRamoCotizacion) => {
        //diferenciar a q peticion mandar
        axios
            .get(routes.api + "/polizas/coberturas", {
                params: {
                    cdCompania: idComp,
                    cdRamoCotizacion: cdRamoCotizacion,
                },
            })
            .then(resp => {
                let cobs = resp.data;
                this.setState({ coberturas: cobs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getGarantias = ramoCot => {
        axios
            .get(routes.api + "/polizas/garantias", {
                params: {
                    ramoCot: ramoCot,
                },
            })
            .then(resp => {
                let list = resp.data;
                this.setState({ garantias: list });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDeducibles = (idComp, ramoCot) => {
        axios
            .get(routes.api + "/polizas/otros-deducibles", {
                params: {
                    cdCompania: idComp,
                    ramoCot: ramoCot,
                },
            })
            .then(resp => {
                let data = resp.data;
                this.setState({ otros: data.otros, deducibles: data.deducibles });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getPagos = (idComp, ramoCoti) => {
        axios
            .get(routes.api + "/polizas/formaPago", {
                params: {
                    cdCompania: idComp,
                    cdCotizacion: ramoCoti,
                    vam: this.props.vida,
                },
            })
            .then(resp => {
                let data = resp.data;
                this.setState({
                    formaPago: data.item,
                    pagos: data.financiamientoList,
                    totalPago: data.totalPago,
                    totalSaldo: data.totalSaldo,
                });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getNotas = cdRamoCoti => {
        axios
            .get(routes.api + "/polizas/notas", {
                params: {
                    cdRamosCotizacion: cdRamoCoti,
                },
            })
            .then(resp => {
                let notas = resp.data.sort((a1, a2) => a1.cdAclaratorio - a2.cdAclaratorio);
                this.setState({ notas: notas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getClausulas = (idComp, ramoCot) => {
        axios
            .get(routes.api + "/polizas/clausulas", {
                params: {
                    cdCompania: idComp,
                    ramoCot: ramoCot,
                },
            })
            .then(resp => {
                let notas = resp.data;
                this.setState({ clausulas: notas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [], item: {} });
    };

    tabSelect = tab => {
        this.setState({ hTabs: tab });
    };

    render() {
        let ramos = this.props.ramos;
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            poliza={this.props.poliza}
                            item={this.props.item}
                            user={this.props.user}
                            vida={this.props.vida}
                            ramos={ramos}
                        />

                        <div className="col-lg-9">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={this.closeModal}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <h5 className="card-title">Detalle Póliza</h5>
                            <Nav pills className="nav-pills-primary">
                                <NavItem className="cursorPointer">
                                    <NavLink
                                        className={this.state.hTabs === "ht1" ? "active" : ""}
                                        onClick={() => this.tabSelect("ht1")}
                                    >
                                        Coberturas
                                    </NavLink>
                                </NavItem>
                                <NavItem className="cursorPointer">
                                    <NavLink
                                        className={this.state.hTabs === "ht2" ? "active" : ""}
                                        onClick={() => this.tabSelect("ht2")}
                                    >
                                        Cláusulas
                                    </NavLink>
                                </NavItem>
                                <NavItem className="cursorPointer">
                                    <NavLink
                                        className={this.state.hTabs === "ht3" ? "active" : ""}
                                        onClick={() => this.tabSelect("ht3")}
                                    >
                                        Deducibles
                                    </NavLink>
                                </NavItem>
                                <NavItem className="cursorPointer">
                                    <NavLink
                                        className={this.state.hTabs === "ht4" ? "active" : ""}
                                        onClick={() => this.tabSelect("ht4")}
                                    >
                                        Garantías
                                    </NavLink>
                                </NavItem>
                                <NavItem className="cursorPointer">
                                    <NavLink
                                        className={this.state.hTabs === "ht5" ? "active" : ""}
                                        onClick={() => this.tabSelect("ht5")}
                                    >
                                        Notas Aclaratorias
                                    </NavLink>
                                </NavItem>
                                <NavItem className="cursorPointer">
                                    <NavLink
                                        className={this.state.hTabs === "ht6" ? "active" : ""}
                                        onClick={() => this.tabSelect("ht6")}
                                    >
                                        Pagos
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.hTabs} className="tab-space">
                                <TabPane tabId="ht1">
                                    <Coberturas
                                        hTabs={this.state.hTabs}
                                        coberturas={this.state.coberturas}
                                        vida={this.props.vida}
                                    />
                                </TabPane>
                                <TabPane tabId="ht2">
                                    <Clausulas hTabs={this.state.hTabs} clausulas={this.state.clausulas} />
                                </TabPane>
                                <TabPane tabId="ht3">
                                    <DeduciblesVehi coberturas={this.state.deducibles} otros={this.state.otros} />
                                </TabPane>
                                <TabPane tabId="ht4">
                                    <Garantias garantias={this.state.garantias} />
                                </TabPane>
                                <TabPane tabId="ht5">
                                    <Notas hTabs={this.state.hTabs} notas={this.state.notas} />
                                </TabPane>
                                <TabPane tabId="ht6">
                                    <Pagos
                                        item={this.state.formaPago}
                                        financiamientoList={this.state.pagos}
                                        totalSaldo={this.state.totalSaldo}
                                        totalPago={this.state.totalPago}
                                    />
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-default" onClick={this.closeModal}>
                        {" "}
                        Cerrar
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}
